<template>
  <div>
    <v-row dense class="mb-5">
      <r-worker-team-table :items.sync="value.teams" title="Teams"/>
    </v-row>
    <v-row dense class="mb-5">
      <r-worker-table :items.sync="value.workers" title="Workers"/>
    </v-row>
    <v-row dense>
      <r-task-config-table :items.sync="value.tasks" title="Tasks"/>
    </v-row>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {JobConfig} from "@/modules/redactor/models/worker/jobs/JobConfig";
import RTaskConfigTable from "@/modules/redactor/views/worker/r-task-config-table";
import RWorkerTable from "@/modules/redactor/views/worker/r-worker-table";
import RWorkerTeamTable from "@/modules/redactor/views/worker/r-worker-team-table";


export default {
  name: "r-job-config",
  components: {RWorkerTeamTable, RTaskConfigTable, RWorkerTable},
  props: {
    model: VueTypes.instanceOf(JobConfig)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new JobConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>